import React from 'react';
import LayoutContainer from '../components/LayoutWrapper';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

const IntelectualPropertyClaim = () => {
    const { address, email } = useSelector(state => state.shop)

    return (
        <LayoutContainer>
            <h2>Intellectual Property Claim</h2>
            <p>
                <strong>COPYRIGHT</strong> law protects the expression of original ideas fixed in a tangible medium, such as visual artwork, written texts, and other creative content.
            </p>
            <p>
                <strong>TRADEMARK</strong> law protects distinctive words, phrases, symbols, or designs that identify and distinguish the source of goods or services.
            </p>
            <p>
                <strong>PUBLICITY RIGHTS</strong> protect an individual’s name, image, voice, or likeness. This means that using someone's personal identity for commercial purposes without their permission is generally prohibited.
            </p>
            <p>
                If you believe your intellectual property rights have been violated, you may submit a Notice and Takedown request. Your report should include the following information:
            </p>
            <ul>
                <li>A link to the content that allegedly infringes your rights</li>
                <li>Proof of ownership (such as a link to your official portfolio, website, or dated records)</li>
                <li>Your full name and a contact phone number</li>
                <li>A subject line clearly marked as: <strong>TAKEDOWN REPORT</strong></li>
            </ul>
            <p>
                Please send your report to the designated contact email found on our Contact page.
            </p>
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </LayoutContainer>
    );
};

export default IntelectualPropertyClaim;
